
import { useState } from "react";
import { useRecipeSubmitHandler } from "@/components/recipe/RecipeSubmitHandler";
import { SubscriptionStatus } from "@/services/subscription";

interface UseRecipeTransformationProps {
  user: any;
  subscriptionStatus: SubscriptionStatus | null;
  onLoadSubscriptionStatus: (userId: string) => Promise<SubscriptionStatus | null>;
  forceRefresh?: () => void;
}

export const useRecipeTransformation = ({
  user,
  subscriptionStatus,
  onLoadSubscriptionStatus,
  forceRefresh
}: UseRecipeTransformationProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [recipeData, setRecipeData] = useState<any>(null);
  const [showPricingModal, setShowPricingModal] = useState(false);
  const [lastTransformTime, setLastTransformTime] = useState(0);
  
  // Use the extracted recipe submit handler
  const { handleRecipeSubmit } = useRecipeSubmitHandler({
    user,
    subscriptionStatus,
    onLoadSubscriptionStatus,
    forceRefresh,
    setShowPricingModal,
    setIsLoading: (loading) => {
      setIsLoading(loading);
      if (!loading && !showPricingModal) {
        // When transformation completes (and pricing modal isn't shown)
        // mark the time so we can trigger a refresh
        setLastTransformTime(Date.now());
      }
    },
    setRecipeData
  });

  return {
    isLoading,
    recipeData,
    showPricingModal,
    setShowPricingModal,
    lastTransformTime,
    handleRecipeSubmit
  };
};
